const fontFamily = '"Open Sans", "Arial", "sans-serif"';
const fontSize = {
    100: '12px',
    200: '14px',
    300: '16px',
    400: '20px',
    500: '24px',
    600: '30px',
    700: '36px',
    800: '48px'
};
const lineHeight = {
    100: '16px',
    200: '20px',
    300: '20px',
    400: '24px',
    500: '28px',
    600: '32px',
    700: '36px',
    800: '48px'
};
const fontWeight = {
    regular: '400',
    bold: '600'
};
const color = {
    'gray-50': '#FDFDFD',
    'gray-100': '#FAFAFA',
    'gray-200': '#F1F1F1',
    'gray-300': '#EBEBEB',
    'gray-400': '#DFDFDF',
    'gray-500': '#BABABA',
    'gray-600': '#898989',
    'gray-700': '#737373',
    'gray-800': '#464646',
    'gray-900': '#323232',
    'gray-950': '#232323',
    'gray-975': '#1B1B1B',
    'primary-100': '#F6F9FF',
    'primary-200': '#DEE9FD',
    'primary-300': '#C6D8FE',
    'primary-400': '#9BBAFD',
    'primary-500': '#75A0FE',
    'primary-600': '#467DFE',
    'primary-700': '#3355F5',
    'primary-800': '#2247AF',
    'primary-900': '#132C6C',
    'accent-100': '#FFF8F5',
    'accent-200': '#FFE5DB',
    'accent-300': '#FFD2C2',
    'accent-400': '#FFAD8F',
    'accent-500': '#F79064',
    'accent-600': '#E96B35',
    'accent-700': '#C54B16',
    'accent-800': '#963308',
    'accent-900': '#5C1C00',
    'success-100': '#EFFBF6',
    'success-200': '#CEF3E3',
    'success-300': '#A5E9CB',
    'success-400': '#5CD6A1',
    'success-500': '#30C081',
    'success-600': '#1DA56A',
    'success-700': '#178254',
    'success-800': '#08633C',
    'success-900': '#004226',
    'danger-100': '#FEF6F6',
    'danger-200': '#FFE5E5',
    'danger-300': '#FFD1D1',
    'danger-400': '#FDAAAA',
    'danger-500': '#F98B8B',
    'danger-600': '#ED5959',
    'danger-700': '#D43535',
    'danger-800': '#A51D1D',
    'danger-900': '#6C0F0F',
    'alert-100': '#FFF8EB',
    'alert-200': '#FFE9C2',
    'alert-300': '#FFD68F',
    'alert-400': '#FFB22E',
    'alert-500': '#F09800',
    'alert-600': '#D07D01',
    'alert-700': '#AD5F00',
    'alert-800': '#804400',
    'alert-900': '#572E00',
    transparent: 'rgba(0,0,0,0.0)',
    black: '#000000',
    white: '#ffffff',
    'templafy-brand': '#3355F5'
};
const spacing = {
    0: '0',
    50: '2px',
    100: '4px',
    200: '8px',
    250: '12px',
    300: '16px',
    350: '20px',
    400: '24px',
    500: '32px',
    550: '40px',
    600: '48px',
    700: '64px'
};
const sizing = {
    50: '12px',
    100: '16px',
    200: '24px',
    300: '32px',
    350: '40px',
    400: '48px',
    500: '64px',
    550: '80px',
    600: '96px',
    700: '128px',
    800: '192px',
    900: '256px',
    1000: '320px',
    1100: '384px',
    1200: '512px',
    1300: '640px',
    1400: '768px',
    1500: '1024px',
    1600: '1280px'
};
const borderWidth = {
    0: '0',
    100: '1px',
    150: '2px',
    200: '3px',
    300: '4px'
};
const borderRadius = {
    50: '3px',
    100: '6px',
    200: '12px',
    rounded: '3px',
    pill: '20em',
    circle: '50%'
};
const shadow = {
    'light-100': '0px 0px 0px 1px rgba(41, 48, 56, 0.06), 0px 1px 2px rgba(41, 48, 56, 0.1), 0px 2px 4px rgba(41, 48, 56, 0.16)',
    'light-200': '0px 0px 0px 1px rgba(41, 48, 56, 0.06), 0px 3px 6px rgba(41, 48, 56, 0.1), 0px 5px 10px rgba(41, 48, 56, 0.12)',
    'light-300': '0px 0px 0px 1px rgba(41, 48, 56, 0.06), 0px 5px 10px rgba(41, 48, 56, 0.1), 0px 13px 26px rgba(41, 48, 56, 0.08)',
    'dark-100': '0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.2)',
    'dark-200': '0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 3px 6px rgba(0, 0, 0, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.2)',
    'dark-300': '0px 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.15), 0px 13px 26px rgba(0, 0, 0, 0.2)'
};
const breakpoint = {
    xs: '640px',
    s: '768px',
    m: '1024px',
    l: '1280px'
};
export { borderRadius, borderWidth, breakpoint, color, fontFamily, fontSize, fontWeight, lineHeight, shadow, sizing, spacing };
